import React from 'react';
import Styles from './styles.module.sass';

import ModuleCardTitle from 'newComponents/ModuleCardTitle';
import ModuleCard from 'newComponents/ModuleCard';
import ModuleCardMenu from 'newComponents/ModuleCardMenu';
import ModuleCardWidgets from 'newComponents/ModuleCardWidgets';

const AsideLayout = ({ cardsService, setUdCard }) => {

    const toggle = () => {
        document.querySelector('main').classList.toggle('showMenu')
    }

    // console.log("cardsService en aside: ", cardsService)

    return(
        <aside className={Styles?.moduleCardMenuContainer}>
            <div className={Styles?.moduleCardMenu}>
                <ModuleCardTitle cardsService={cardsService} />
                <ModuleCard cardsService={cardsService} setUdCard={setUdCard} clase="menuCard"/>
                <ModuleCardMenu />
                <ModuleCardWidgets />
            </div>
            <div className={Styles?.darkMenu} onClick={toggle}></div>
        </aside>
    )
}

export default AsideLayout;